import React, { useRef, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Top from '../Top/Top';
import TemplateParser from '../Templates/TemplateParser';
import { offset, scrollTo } from '../../utils/dom';
import { deepClone } from '../../utils/object';
import s from './Page.scss';

const Page = ({ data, location, setup, pageType, hashLocation = false }) => {
	if (!data || ['page', 'start', '404'].indexOf(pageType) === -1) return null;
	const pageSections = useRef(null);
	const pageElement = useRef(null);

	/* INTERNAL SCROLL */

	const scrollToHash = () => {
		let imagesLoaded = null;
		const localHashLocation = hashLocation || window.location.hash;

		const allLoaded = () => {
			if (pageElement && pageElement.current) {
				const imgs = pageElement.current.querySelectorAll('img');
				imagesLoaded = [...imgs].length;

				[...imgs].forEach((img) => {
					if (img.complete) imagesLoaded -= 1;
				});
			}

			if (pageElement && pageElement.current && imagesLoaded === 0) {
				// Delay to understand page navigation
				setTimeout(() => {
					const position = offset(document.getElementById(localHashLocation.replace('#', ''))).top - 80;
					scrollTo(500, position);
				}, 300);
			} else {
				setTimeout(allLoaded, 50);
			}
		};

		allLoaded();
	};

	useEffect(() => {
		if (hashLocation || window.location.hash !== '') scrollToHash();
	});

	/* EXTRA PARTS */

	// Check if page contains core/block
	if (data.parts) {
		const removeParts = [];

		data.content.sections.map((section) => {
			if (Object.keys(section)[0] === 'coreBlock') {
				const whichPart = section.coreBlock.content;

				data.parts.forEach((part, i) => {
					if (part.meta.id === whichPart) {
						section.coreBlock.content = deepClone(part.sections);
						removeParts.push(i);
					}
				});

				return section;
			}
			return section;
		});

		removeParts.forEach((rPart) => {
			data.parts = [...data.parts.slice(0, rPart), ...data.parts.slice(rPart + 1)];
		});
	}

	return (
		<main role="main">
			<Top setup={setup} pageContent={data.content.meta?.[setup.language] || data.content.meta.default} paths={data.paths} locationType={location.type} />
			<div className={[s.page]} ref={pageElement}>
				<div className={s.page_inner} ref={pageSections}>
					{ data.content && <TemplateParser meta={data.content.meta} sections={data.content.sections} setup={setup} /> }
					{
						data.parts && data.parts.length > 0 && data.parts.map((section) => (
							<TemplateParser sections={section.sections} setup={setup} />
						))
					}
				</div>
			</div>
		</main>
	);
};

const mapState = ({ environment, location }, { data, pageType }) => ({
	data,
	hashLocation: environment.hashLocation,
	setup: environment.setup,
	environment,
	location,
	pageType,
});

export default hot(module)(connect(mapState)(Page));
